{
  "modal_message": "¿Ya tiene la aplicación de Gucci?",
  "modal_yes": "SÍ",
  "modal_no": "NO"
}
